// src/routes/BuildingTisoto.js
import './pages.css';
export const BuildingTisoto = () =>{
    return (
        <div className='main'>
            <a href=".." >&lt;マップに戻る</a>
            <h1>地域創生総合研究棟</h1>
            <table border="1">
                <tr>
                    <th>緯度経度</th>
                    <th>緯度26度15分11秒958 経度127度45分57秒202</th>
                </tr>
                <tr>
                    <th>Plus Code</th>
                    <th>7Q38+88Q 西原町、沖縄県</th>
                </tr>
                <tr>
                    <th>what3words</th>
                    <th>&#47;&#47;&#47;さいど。かくれんぼ。よくじつ</th>
                </tr>
            </table>
            <h2>主な施設</h2>
            <h3>一階</h3>
                <a href='https://ryulab.jp/'>STARTUP LAB RYUDAI 琉ラボ</a>

            <h2>アクセス</h2>
            <p>
                北口から：徒歩約5分<br></br>
                北食堂から：徒歩約4分
            </p>

            <h2>備考</h2>
            <p>
                とても新しい建物<br></br>
                様々な企業が入居している
            </p>
        </div>
    )
}
